import $ from 'jquery';
import ModalValidationHandler from 'validator/modal-validation-handler';
import { FetchHandler } from 'components/fetchhandler';

export default class Modal {

    private modalSelector !: JQuery;

    /**
     * Add modal click listener.
     *
     */
    public modalClickListener(selector : string) : void {
        $(selector)
        .on('click.modalClick', (event : JQuery.TriggeredEvent) => {
            this.open(
                $(event.currentTarget).attr('data-show-modal') as string,
            );
        });
    }

    /**
     * Open modal.
     */
    public open(modalDataEndpoint : string, callback ?: null | Function) : void {
        this.getMainModal().modal();

        this.loadContent(
            modalDataEndpoint,
            callback,
        );
    }

    public isThereModalOpen() : boolean {
        return !!(this.getMainModal()
        .data('bs.modal')
        ?._isShown
        );
    }

    /**
     * Load modal html.
     *
     * @param {string} modalDataEndpoint - The given endpoint to fetch the modal html
     */
    private loadContent(modalDataEndpoint : string, callback ?: null | Function) : void {
        if (this.getMainModal().find('.modal-loading').length > 0) {
            this.reset();
        }

        FetchHandler.create()
        .setMethod('GET')
        .setXMLHttpRequest()
        .setUrl(modalDataEndpoint)
        .setContentType('text/json')
        .send()
        .then((response : {html : string}) => {
            this.getMainModal().html(response.html);

            const form = this.getMainModal().find('form');
            if (form.length > 0) {
                const formId = form.attr('id');
                if (typeof formId !== 'undefined') {
                    ModalValidationHandler(
                        formId,
                        // eslint-disable-next-line no-use-before-define
                        this.open,
                    );
                }
            }

            const modalOpener = this.getMainModal().find('[data-show-modal]');
            if (modalOpener.length > 0) {
                this.modalClickListener('#main-modal-container [data-show-modal]');
            }

            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            throw error;
        });
    }

    /**
     * Reset modal to the loading state.
     */
    private reset() : void {
        const modalContent = this.getMainModal().find('.modal-content');

        modalContent.attr('class', 'modal-content modal-loading');
        modalContent.html('<div class="spinner-border" role="status"></div>');
    }

    private getMainModal() : JQuery {
        if (typeof this.modalSelector === 'undefined') {
            this.modalSelector = $('#main-modal-container');

            this.modalSelector.on(
                'hidden.bs.modal',
                () => {
                    this.reset();
                },
            );

        }
        return this.modalSelector;
    }

}
